/**
 * Calculates the correct index for circular carousel navigation.
 * For example, with 5 items:
 * - Going forward from index 4 wraps to 0
 * - Going backward from index 0 wraps to 4
 *
 * @param index - The current index (can be positive or negative)
 * @param length - The total number of items
 * @returns The wrapped index that's always between 0 and (length-1)
 */
export const wrapIndex = (index: number, length: number) => {
    // ((index % length) + length) % length ensures we get a positive result
    // even for very large negative numbers
    return ((index % length) + length) % length;
};
